// Oś czasu: rudy szlak dorysowuje się razem z przewijaniem, a krążki kolejnych kroków wyskakują, gdy szlak do nich dojdzie.
import {gsap, $$} from "./shared";

export function initTimelines() {
    $$(".cc-timeline").forEach((list) => {
        const steps = [...list.children];
        if (!steps.length) {
            return;
        }
        const tl = gsap.timeline({
            scrollTrigger: {trigger: list, start: "top 78%", end: "bottom 60%", scrub: 0.8}
        });
        tl.fromTo(list, {"--progress": 0}, {"--progress": 1, ease: "none", duration: 1}, 0);
        steps.forEach((step, i) => {
            const at = steps.length > 1 ? (i / (steps.length - 1)) * 0.86 : 0;
            const badge = step.querySelector(".cc-timeline__badge");
            const texts = step.querySelectorAll(".cc-timeline__title, .cc-timeline__text");
            if (badge) {
                tl.from(badge, {scale: 0, rotation: -120, duration: 0.14, ease: "back.out(2.5)"}, at);
            }
            if (texts.length) {
                tl.from(texts, {y: 20, autoAlpha: 0, duration: 0.12, stagger: 0.03}, at + 0.03);
            }
        });
    });
}
